module.exports = "h3 {\n  width: 100%; }\n\nbutton {\n  top: -5px; }\n\nbutton.delete-button {\n    color: red; }\n"